import { AxiosInstance } from 'axios';
import { WarehouseActivityAttributes, WarehouseAttributes } from '../../types/apiType';
import { PaginatedQueryParams } from '../../types/common';

export default class FormulaService {
  constructor(private axios: AxiosInstance) {}

  getListWarehouse = async () => {
    const { data } = await this.axios.get('warehouses');
    return data;
  };

  getWarehouseById = async (id: string) => {
    const { data } = await this.axios.get(`warehouses/${id}`);
    return data;
  };

  addWarehouse = async (value: WarehouseAttributes) => {
    const { data } = await this.axios.post('warehouses', value);
    return data;
  };

  updateWarehouse = async (id: string, value: WarehouseAttributes) => {
    const { data } = await this.axios.put(`warehouses/${id}`, value);
    return data;
  };

  getListActivities = async (warehouseId: string, params: PaginatedQueryParams) => {
    const { data } = await this.axios.get(`warehouses/${warehouseId}/activities`, { params });
    return data;
  };

  addActivity = async (warehouseId: string, value: WarehouseActivityAttributes) => {
    const { data } = await this.axios.post(`warehouses/${warehouseId}/activities`, value);
    return data;
  };

  updateActivity = async (warehouseId: string, activityId: string, value: WarehouseActivityAttributes) => {
    const { data } = await this.axios.put(`warehouses/${warehouseId}/activities/${activityId}`, value);
    return data;
  };

  removeActivity = async (warehouseId: string, activityId: string) => {
    const { data } = await this.axios.delete(`warehouses/${warehouseId}/activities/${activityId}`);
    return data;
  };

  autosuggest = async (params: { target: string; search: string }) => {
    const { data } = await this.axios.get(`warehouses/autosuggest`, { params });
    return data;
  };

  getReports = async (warehouseId: string, params: { start: string; end: string }) => {
    const { data } = await this.axios.get(`warehouses/${warehouseId}/reports`, { params });
    return data;
  };

  getProductReports = async (warehouseId: string, params: { start: string; end: string }) => {
    const { data } = await this.axios.get(`warehouses/${warehouseId}/products/reports`, { params });
    return data;
  };
}
